import api from '../services/api';
import { $Q, $Qll } from '../utils/query-selector';
import { registerEmailInKlaviyo } from '../services/klaviyo';

/**
 *
 * @param {String} param0 - Phone number format
 * @param {Boolean} param1 - User accept marketing
 * @returns Save on localStorage info
 */
const registerStorageInfo = ({ phone = '', marketing = false }) => {
  const body = {
    accept_marketing: marketing,
  };

  if (phone !== '') {
    body['phone'] = phone;
  }

  sessionStorage.setItem('register-attempt', true);

  if (phone === '' && !marketing) return;

  return localStorage.setItem('infoCustomer', JSON.stringify(body));
};

/**
 * Validation Phone number
 * On HTML message
 */
const enterValidPhone = () => {
  const message = $Q('#RegisterForm-phone-error');
  message.style.display = 'flex';
};

/**
 * On submit registratio form
 * @param {EventListener} event - Submit event form
 * @returns Validation or submit registratio
 */
const onSubmitRegistration = async (event) => {
  event.preventDefault();
  $Q('#RegisterForm-phone-error').style.display = 'none';

  const form = event.target;
  const phone = $Q('[name="customer[phone]"]', form).value;
  const marketing = $Q('[name="customer[consent]"]', form).checked;

  const userEmail = $Q("#RegisterForm-email").value;
  const lang = $Q("html").getAttribute("lang");
  registerEmailInKlaviyo(userEmail, lang);

  if (!phone) {
    registerStorageInfo({ phone, marketing });
    form.submit();
    return;
  }

  $Q('#button-signup .loading').classList.remove('hidden');
  $Q('#button-signup span').classList.add('hidden');

  $Q('#button-signup .loading').classList.add('hidden');
  $Q('#button-signup span').classList.remove('hidden');


  const currentInputPhone = window.intlTelInputGlobals.getInstance($Q("#RegisterForm-phone"));

  if (currentInputPhone.isValidNumber()) {
    registerStorageInfo({ phone, marketing });
    form.submit();
  }
};

/**
 * It removes onsubmit attribute added by shopify
 * @param {HTMLElement} form : It is the form parent
 */
const removeDefaultSubmit = (form) => {
  const inputs = $Qll('input', form);

  if (!inputs) return;

  inputs.forEach((input) => {
    input.addEventListener('focus', () => {
      setTimeout(() => {
        form.removeAttribute('onsubmit');
      }, 300);
    });
  });
};

/**
 * On load event submit: Validation phone and marketing info
 */
window.addEventListener('load', async () => {
  const phoneForm = $Q("#RegisterForm-phone");
  if (phoneForm) {
    window.intlTelInput(phoneForm,{
      preferredCountries:['FR','GB','DE','IT']
    })
  };

  const form = $Q('.manual-registration-js[id="create_customer"]');
  if (form) {
    form.addEventListener('submit', onSubmitRegistration);
    removeDefaultSubmit(form);
  }
});

/**
 * For each load page: The information customer should be update then we clean storage
 */
export const onLoadUserData = async () => {
  const infoStorage = JSON.parse(localStorage.getItem('infoCustomer'));

  if (infoStorage && customer.email) {
    const marketingPayload = {
      email: customer.email,
      accept_marketing: infoStorage.accept_marketing,
    };

    const phonePayload = {
      email: customer.email,
      accept_marketing: infoStorage.accept_marketing,
      phone: infoStorage.phone,
    };
    try {
      await api.updateCustomer(marketingPayload);
      if (infoStorage.phone !== '' && infoStorage.phone !== undefined) {
        await api.updateCustomer(phonePayload);
      }
      localStorage.removeItem('infoCustomer');
    } catch (error) {
      console.log(error.message);
    }
  }
};

/**
  Display the phone number information message
 */

const phoneInput = $Q("#RegisterForm-phone");
const phoneInfoMessage = $Q("#RegisterForm-phone-information");

function handleInputClick() {
  phoneInfoMessage.classList.remove("hidden");
}

function handleMsgInput() {
  phoneInfoMessage.classList.add("hidden");
}

if (phoneInput && phoneInfoMessage) {
  phoneInput.addEventListener("click", handleInputClick);
  phoneInput.addEventListener("input", handleMsgInput);
}
